import {
  BadgeDollarSign,
  BriefcaseBusiness,
  ClockArrowUp,
  FolderKanban,
  GraduationCap,
  Ham,
  HandCoins,
  HeartPulse,
  MessageCircleMore,
  UserRound,
} from 'lucide-react';

export default function CustomIconBusinessProcess({
  businessProcessKey,
  size,
  stroke,
  fill,
  className,
}: {
  businessProcessKey: string;
  size?: number;
  stroke?: string;
  fill?: string;
  className?: string;
}) {
  const businessProcessProps = {
    stroke,
    size,
    fill,
    className,
  };

  const businessProcessIcons: { [key: string]: JSX.Element } = {
    PengajuanReimburse: <HandCoins {...businessProcessProps} />,
    EvaluasiSprint: <FolderKanban {...businessProcessProps} />,
    lembur: <ClockArrowUp {...businessProcessProps} />,
    tell_us: <MessageCircleMore {...businessProcessProps} />,
    tunjangan_kesehatan: <HeartPulse {...businessProcessProps} />,
    prosesKehadiranMakanSiang: <Ham {...businessProcessProps} />,
    PencairanJpoint: <BadgeDollarSign {...businessProcessProps} />,
    PengajuanCoaching: <GraduationCap {...businessProcessProps} />,
    Onboarding_tim: <UserRound {...businessProcessProps} />,
  };

  return businessProcessIcons[businessProcessKey] || <BriefcaseBusiness {...businessProcessProps} />;
}
